import { render, staticRenderFns } from "./PgarhNumberOverviewPage.vue?vue&type=template&id=d082a838&scoped=true&"
import script from "./PgarhNumberOverviewPage.vue?vue&type=script&lang=js&"
export * from "./PgarhNumberOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PgarhNumberOverviewPage.vue?vue&type=style&index=0&id=d082a838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d082a838",
  null
  
)

export default component.exports